import {Vue, Component, Prop} from 'vue-property-decorator';
import {ModalLayout} from '@appbase/templates'
import modalHelper from '@appbase/util/modal-helper';
import VueAES from "@appbase/util/vue-aes";
import apiAccount  from '@account/api'

@Component({
    name: 'change-init-password-modal',
    components: {
        ModalLayout
    },
})
export default class ChangeInitPasswordModal extends Vue {

    @Prop({ type: String }) username!: string;

    password: string = '';
    newPassword: string = '';
    errors: string[] = [];

    validate(){
        if(this.password == '' || this.newPassword == ''){
            this.errors.push(this.$t("암호가_필요합니다").toString());
            return false;
        }

        if(this.password == this.newPassword){
            this.errors.push(this.$t("암호가_같습니다").toString());
            return false;
        }

        if(this.newPassword.length > 50){
            this.errors.push(this.$t("암호는_50자_이하여야_합니다").toString());
            return false;
        }

        return true;
    }

    async updateInitPassword(e: Event){
        e.preventDefault();
        this.errors = [];

        try{
            if(this.validate()){
                var result = await apiAccount.account.changeInitPassword(this.username, this.password, this.newPassword);
                if((typeof result == 'boolean') && result){
                    this.save();
                }
                else{
                    (window as any).alertAsync(this.$t('문제가_발생했습니다_다시_시도해주시기_바랍니다').toString());
                }
            }
        }
        catch(e){
            console.error(e);
            const serverErrors = (e as any).data?.errors;
            if (serverErrors) {
                this.errors = [...this.errors, ...serverErrors];
            } else {
                this.errors.push(e as any);
            }
        }
    }

    save(){
        this.$emit("save");
    }

    cancel() {
        this.$emit('cancel');
    }
}